import { render, staticRenderFns } from "./PanelCreate.vue?vue&type=template&id=d9d485f0&scoped=true&"
import script from "./PanelCreate.vue?vue&type=script&lang=js&"
export * from "./PanelCreate.vue?vue&type=script&lang=js&"
import style0 from "./PanelCreate.vue?vue&type=style&index=0&id=d9d485f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d485f0",
  null
  
)

export default component.exports